import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { DrawerBox, DrawerItems } from '@/components/Drawer/Drawer.styles';
import { Chip as ChipComponent } from '@/components/UI/Chip/Chip';
import { Button } from '@/components/UI/Button/Button';

export const DrawerItem = styled(DrawerItems)`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 20px 15px;
  border-radius: 21px;
  border: none;
  margin: 5px 0 0;
`;

export const FieldTitle = styled(Typography.Title)`
  color: ${({ theme }) => theme.palette.primary.labels};
  font-size: 16px;
`;

export const PriceFieldTitle = styled(FieldTitle)`
  padding: 5px 0;
`;

export const FieldWithTitleWrapper = styled.div<{ $hasPadding?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 15px;
  ${({ $hasPadding }) =>
    $hasPadding &&
    css`
      padding: 10px 0;
    `}
`;

export const TwoFieldsInRow = styled.form`
  display: flex;
  gap: 15px;
`;

export const FiltersDrawerCTA = styled.div`
  position: sticky;
  bottom: 0;
  width: 100%;
  margin-top: auto;
  padding: 10px 15px 25px;
  border-top: 1px solid ${({ theme }) => theme.palette.primary.border};
  background-color: ${({ theme }) => theme.palette.primary.background};
  z-index: 3;

  body.ios ${DrawerBox}:focus-within & {
    position: static;
    margin-top: 0;
  }
`;

export const ChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

export const Chip = styled(ChipComponent)`
  height: 40px;
  border-radius: 100px;
  user-select: none;
`;

export const ApplyButton = styled(Button)`
  border-radius: 14px;
  padding: 15px 35px;
  height: 54px;
`;

export const CollectionSelectFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;
